import { skipToken } from '@reduxjs/toolkit/query/react';
import { useGetGraphProfilePhotoQuery } from '@store/api';

interface ProfilePhotoState {
  photoUrl: string | null;
  isLoading: boolean;
}

/**
 * Thin store-composition wrapper (feature 107): reads the signed-in user's Microsoft Graph
 * profile photo (a base64 data URL) from the store's `mediaService` instead of calling the
 * graph service directly and managing object-URL lifecycle. The query is skipped until an
 * email is known, preserving the previous gating behavior.
 */
export function useProfilePhoto(userEmail: string | undefined | null): ProfilePhotoState {
  const { data, isLoading, isFetching } = useGetGraphProfilePhotoQuery(
    userEmail ? undefined : skipToken
  );

  return {
    photoUrl: data?.dataUrl ?? null,
    isLoading: !!userEmail && (isLoading || isFetching),
  };
}
